"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledToastProvider = void 0;
var _ToastProvider = require("./ToastProvider");
// TODO: in v9, move styled() from ToastProvider.jsx to here
var StyledToastProvider = _ToastProvider.ToastProvider;
exports.StyledToastProvider = StyledToastProvider;